import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

interface ICalcFn {
  item: ISobCompetitor
  field: string
  value: number
  hpItem?: ISobCompetitor
}

export const getRelatedFields = (field: string) => {
  switch (field) {
    case 'CurrentYearQ1ActualsSob':
    case 'CurrentYearQ2ActualsSob':
    case 'CurrentYearQ3ActualsSob':
    case 'CurrentYearQ4ActualsSob':
    case 'PrevYearQ1ActualsSob':
    case 'PrevYearQ2ActualsSob':
    case 'PrevYearQ3ActualsSob':
    case 'PrevYearQ4ActualsSob':
      return {
        calcFn: ({ item, field, value }: ICalcFn) => {
          return { ...item, [field]: value }
        },
      }

    default:
      return {
        calcFn: ({ item }: ICalcFn) => {
          return {
            ...item,
          }
        },
      }
  }
}
